import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DeleteWebhookUrlVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteWebhookUrl = {
  deleteWebhookUrl: boolean
};


export const DeleteWebhookUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWebhookUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWebhookUrl"}}]}}]} as unknown as DocumentNode<DeleteWebhookUrl, DeleteWebhookUrlVariables>;